import { Api } from "../api";
import { AxiosResponse } from "axios";

/**
 * @typedef {{
 *  id: number,
 *  submissionId: number,
 *  year: number,
 *  title: string,
 *  instructionText: string }} MunicipalQuestionnaire
 */

const api = new Api("api/municipalities");

/**
 * @param municipalityId
 * @param year
 * @returns {Promise<AxiosResponse<MunicipalQuestionnaire>>}
 */
export const getRiskQuestionnaire = (municipalityId, year) =>
  api.get(`/${municipalityId}/questionnaires/${year}/risk`);

export const postRiskQuestionnaire = (municipalityId, year, payload) =>
  api.post(`/${municipalityId}/questionnaires/${year}/risk`, payload);

export const updateRiskQuestionnaire = (municipalityId, year, id, payload) =>
  api.put(`/${municipalityId}/questionnaires/${year}/risk/${id}`, payload);

export const getAssetQuestionnaire = (municipalityId, year) =>
  api.get(`/${municipalityId}/questionnaires/${year}/asset`);

export const postAssetQuestionnaire = (municipalityId, year, payload) =>
  api.post(`/${municipalityId}/questionnaires/${year}/asset`, payload);

export const updateAssetQuestionnaire = (municipalityId, year, id, payload) =>
  api.put(`/${municipalityId}/questionnaires/${year}/asset/${id}`, payload);
